/**
 * Variance flag threshold pill — small editable input used to set the
 * "above X%, paint the variance cell red" cutoff for NC / PackoutNC
 * grids. Lives in its own component so it can be anchored to the right
 * of the forecast panel (below the calc-packs row) rather than inside
 * the NCForecastGrid's control bar.
 */

import { observer } from 'mobx-react';
import { InputNumber, InputNumberValueChangeEvent } from 'primereact/inputnumber';

import { useEditStore } from './editStoreContext';
import styles from './varianceFlagPill.module.scss';

const VarianceFlagPill = observer(() => {
  const store = useEditStore();

  return (
    <div className={styles.row}>
      <div className={styles.pill} aria-label="Variance flag threshold">
        <span>Flag:</span>
        <InputNumber
          value={store.varianceThreshold}
          onValueChange={(e: InputNumberValueChangeEvent) =>
            store.setVarianceThreshold(e.value ?? 15)
          }
          suffix="%"
          min={1}
          // No effective upper cap — users may legitimately set very
          // high thresholds (e.g. 250 %) to effectively disable
          // flagging on a high-variance forecast. We keep a generous
          // hard ceiling on the store + backend validator so a stray
          // paste can't crash arithmetic, but the input itself doesn't
          // block typing.
          showButtons={false}
          inputClassName={styles.input}
        />
      </div>
    </div>
  );
});

export default VarianceFlagPill;
